import { useState } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

const TagsInput = ({ tags = [], onChange, readOnly = false }) => {
  const [input, setInput] = useState('');

  const handleKeyDown = (e) => {
    if (readOnly) return;
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const val = input.trim();
      if (val && !tags.includes(val)) {
        onChange([...tags, val]);
      }
      setInput('');
    }
    if (e.key === 'Backspace' && !input && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  };

  const handleRemove = (index) => {
    if (readOnly) return;
    onChange(tags.filter((_, i) => i !== index));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        alignItems: 'center',
        border: '1px solid',
        borderColor: readOnly ? 'divider' : 'grey.400',
        borderRadius: 1,
        p: 1,
        minHeight: 42,
        bgcolor: readOnly ? 'grey.50' : 'background.paper',
      }}
    >
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          size="small"
          onDelete={readOnly ? undefined : () => handleRemove(index)}
          sx={{ fontSize: '0.8rem' }}
        />
      ))}
      {!readOnly && (
        <TextField
          variant="standard"
          placeholder={tags.length === 0 ? 'Type and press Enter...' : ''}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          InputProps={{ disableUnderline: true }}
          sx={{
            flex: 1,
            minWidth: 100,
            '& .MuiInputBase-input': { p: 0, fontSize: '0.85rem' },
          }}
        />
      )}
    </Box>
  );
};

export default TagsInput;
